import { Modal, InstallationsSummary } from '@/components'
import InstallationsModal from '@/components/modals/InstallationsModal'
import { t } from '@/i18n'
import React, { useState } from 'react'
import { useWatch, Control } from 'react-hook-form'

interface Props {
  isEditing?: boolean
  emptyValue?: string | null
  control: Control<any>
  [x: string]: any
}

const ProposalInstallationFormComponents: React.FC<Props> = ({
  isEditing,
  emptyValue,
  control,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const installations = useWatch({
    control,
    name: 'installations',
    defaultValue: [],
  })

  return (
    <>
      <InstallationsSummary
        installations={installations}
        isEditing={isEditing}
        showManageButton={true}
        onManageClick={() => setIsModalOpen(true)}
      />

      <Modal
        visible={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        title={t('manage_installations')}
      >
        <InstallationsModal
          control={control}
          isEditing={isEditing}
          emptyValue={emptyValue}
          onClose={() => setIsModalOpen(false)}
        />
      </Modal>
    </>
  )
}

export default ProposalInstallationFormComponents
